var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"overflow-y-auto",attrs:{"max-height":_vm.maxHeight ? _vm.maxHeight : 1000}},[_c('div',{staticClass:"d-flex flex-column-reverse"},_vm._l((_vm.logs),function(log,time){return _c('LtComment',{key:time,staticClass:"bt-1 mt-1 pt-1",attrs:{"time":time,"log":log}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }